import { ContextSchema, SchemaDetail, schemaPath } from './types'

const PRIVACY_SETTINGS_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'privacy_setting',
  format: 'jsonschema',
  version: '1-0-0',
}

export const privacySettingsContextSchema = (
  data: PrivacySettingsContextSchemaData
): ContextSchema<PrivacySettingsContextSchemaData> => {
  return {
    schema: schemaPath(PRIVACY_SETTINGS_SCHEMA),
    data,
  }
}

/**
 * Schema for Privacy Setting entity. Send null when the setting is not avaialble.
 */
export type PrivacySettingsContextSchemaData = {
  /**
   * Value of Follow Request setting
   */
  follow_requests: boolean | null
  /**
   * Value of Hide Your Posts On Public Timeline setting
   */
  hide_post_public_timeline: boolean | null
  /**
   * Value of Hide Your Posts On Your Profile Page setting
   */
  hide_post_profile_page: boolean | null
  /**
   * Value of Don't Allow Other To Repost Your Posts setting
   */
  do_not_allow_repost: boolean | null
  /**
   * Value of Hide Your Account In User Search Result setting
   */
  hide_from_user_search: boolean | null
  /**
   * Value of Hide Your Account In Friends List From Twitter and Contacts setting
   */
  hide_from_contacts: boolean | null
  /**
   * Value of Message From Following Only setting
   */
  allow_message_from_following: boolean | null
  /**
   * Value of Message From Users Who Recently Got Reported And So On setting
   */
  message_from_recent_reported_users: boolean | null
  /**
   * Value of Letter From Following Only setting
   */
  letter_from_following: boolean | null
  /**
   * Value of Age Gap Restriction setting
   */
  age_gap_restriction: boolean | null
  /**
   * Value of Recieve Private Voice Call setting
   */
  receive_private_voice_call: boolean | null
  /**
   * Value of Recieve Private Video Call setting
   */
  receive_private_video_call: boolean | null
  /**
   * Value of Recieve Disruptive Group Chat Voice Call setting
   */
  receive_disruptive_chat_voice_all: boolean | null
  /**
   * Value of Recieve Disruptive Group Chat Video Call setting
   */
  receive_disruptive_chat_video_all: boolean | null
  /**
   * Value of Get Call Invites Only From Your Followings setting
   */
  allow_invite_from_following: boolean | null
  /**
   * Value of Get Group Invites Only From Your Following setting
   */
  allow_group_invite_from_following: boolean | null
  /**
   * Value of Hide Onlie Status setting
   */
  hide_online_status: boolean | null
  /**
   * Value of Hide In Call Invitation setting
   */
  hide_from_call_invitation_list: boolean | null
  /**
   * Value of Hide Call Status on Profile Page setting
   */
  hide_call_status: boolean | null
  /**
   * Value of Hide VIP badge setting
   */
  hide_vip_badge: boolean | null
  /**
   * Value of Hide Your Footprint setting
   */
  hide_foot_print: boolean | null
  /**
   * Value of Notify Followers On Your Birthday setting
   */
  notify_follower_birthday: boolean | null
  /**
   * Value of Passcode Lock Screen setting
   */
  passcode_lock: boolean | null
}
